import { styled } from 'linaria/react';

import { COLORS, FONTS } from '../../../styles/constants';

interface IStyledAvatarProps {
  dimension: number;
  src?: string | null;
  color: string;
  isGreenBorder?: boolean | null;
  isAnimated?: boolean;
  $isFeedItemRoute?: boolean;
  clickable?: boolean;
}

const StyledAvatar = styled.div<IStyledAvatarProps>`
  align-items: center;
  background-color: ${COLORS.brown.light[100]};
  background-image: ${({ src }) => (src ? `url('${src}')` : 'none')};
  background-position: center;
  background-size: cover;
  border: ${({ isGreenBorder }) => (isGreenBorder ? `2px solid ${COLORS.green.light}` : 'none')};
  border-radius: 50%;
  color: ${({ color }) => color};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  display: block;
  font-family: ${FONTS.primary};
  font-size: ${({ dimension }) => dimension / 3}px;
  height: ${({ dimension }) => dimension}px;
  line-height: 120%;
  min-width: ${({ dimension }) => dimension}px;
  position: relative;
  text-transform: uppercase;
  width: ${({ dimension }) => dimension}px;
  text-align: center;
  transform-origin: center center;

  &.animated {
    transform: translateY(294px) scale(0.05);
    opacity: 0;
  }

  &.animated-end {
    transform: translateY(0) scale(1);
    opacity: 1;
  }

  svg {
    height: 38%;
    width: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default StyledAvatar;
